import { useEffect, useRef } from 'react';
export function useIntersectionReveal(classNameVisible = 'visible') {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        el.classList.add('observer-base');
        const obs = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add(classNameVisible);
                    obs.unobserve(e.target);
                }
            });
        }, { threshold: 0.15 });
        obs.observe(el);
        return () => obs.disconnect();
    }, [classNameVisible]);
    return ref;
}
